import { render } from "./SensorDialog.vue?vue&type=template&id=9f3f10ba&scoped=true"
import script from "./SensorDialog.vue?vue&type=script&lang=ts"
export * from "./SensorDialog.vue?vue&type=script&lang=ts"

import "./SensorDialog.vue?vue&type=style&index=0&id=9f3f10ba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9f3f10ba"

export default script